import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPreviousAppVersionFile, getShowAppVersionRefreshNotification } from 'extractFromState';
import { setPreviousAppVersionFile, setShowAppVersionRefreshNotification } from 'actions';
import { Container } from './AppVersionRefreshNotification.styles';
import { handleError } from 'services/ErrorService/ErrorService';

/*
Sources:
https://marmelab.com/blog/2016/08/29/auto-reload-spa-on-mobile-setinterval.html
https://serviceworke.rs/message-relay_index_doc.html
*/

class AppVersionRefreshNotification extends Component {
  intervalId = 0;

  componentDidMount() {
    // Fetch the version file and start the polling to compare.
    this.checkForNewAppVersion();
    const intervalInMinutes = 5;
    const intervalInMS = intervalInMinutes * 60 * 1000;

    this.intervalID = setInterval(this.checkForNewAppVersion, intervalInMS);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  checkForNewAppVersion = async () => {
    try {
      const response = await fetch('/simplrVersion.html');

      if (!response || response.status !== 200) {
        throw new Error('CheckForNewAppRevision: Http error = ' + response ? response.status : '<Unknown Error>');
      }

      const versionFile = await response.text();

      if (!!this.props.previousAppVersionFile && this.props.previousAppVersionFile !== versionFile) {
        this.props.setShowAppVersionRefreshNotification(true);
      }

      this.props.setPreviousAppVersionFile(versionFile);
    } catch (error) {
      handleError({ error, customMessage: 'CheckForNewAppRevision: Could not download application version file' });
    }
  };

  render() {
    if (this.props.showAlert) {
      return (
        <Container>
          <h1>New version of our application is available</h1>
          <p>
            Please press restart.
            <br /> <span>(Note this will erase any unsent messages)</span>
          </p>
        </Container>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  previousAppVersionFile: getPreviousAppVersionFile(state),
  showAlert: getShowAppVersionRefreshNotification(state),
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setPreviousAppVersionFile,
      setShowAppVersionRefreshNotification,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AppVersionRefreshNotification);
